// Dourado vocabulary expansion — NATURE theme (net-new cards).
//
// Extends the `nature` blocks in ./vocabulary.js without reusing any headword
// already defined there. Seed upserts on `portuguese`, so every value is unique.
//   [ portuguese, english, emoji, part_of_speech, gender, example_pt, example_en ]

export const VOCAB_NATURE = [
  {
    theme: "nature", tier: "A1", rows: [
      ["a lua", "moon", "🌙", "noun", "f", "A lua brilha esta noite.", "The moon is shining tonight."],
      ["a estrela", "star", "⭐", "noun", "f", "Vimos milhares de estrelas no campo.", "We saw thousands of stars in the countryside."],
      ["o peixe", "fish", "🐟", "noun", "m", "Há um peixe no tanque.", "There's a fish in the pond."],
      ["o cavalo", "horse", "🐴", "noun", "m", "O cavalo corre pelo prado.", "The horse runs through the meadow."],
      ["a vaca", "cow", "🐄", "noun", "f", "A vaca pasta na encosta.", "The cow grazes on the hillside."],
      ["a rocha", "rock", "🪨", "noun", "f", "Sentámo-nos numa rocha grande.", "We sat on a big rock."],
      ["a areia", "sand", "🏖️", "noun", "f", "A areia está quente ao meio-dia.", "The sand is hot at midday."],
      ["o lago", "lake", "🏞️", "noun", "m", "Nadamos no lago no verão.", "We swim in the lake in summer."],
      ["a relva", "grass", "🌿", "noun", "f", "A relva está molhada do orvalho.", "The grass is wet with dew."],
      ["o inseto", "insect", "🐛", "noun", "m", "Um inseto pousou na folha.", "An insect landed on the leaf."],
    ],
  },
  {
    theme: "nature", tier: "A2", rows: [
      ["a selva", "jungle / rainforest", "🌴", "noun", "f", "A selva amazónica é enorme.", "The Amazon rainforest is huge."],
      ["o deserto", "desert", "🏜️", "noun", "m", "Atravessaram o deserto de camelo.", "They crossed the desert by camel."],
      ["a gruta", "cave", "🕳️", "noun", "f", "Explorámos uma gruta com morcegos.", "We explored a cave with bats."],
      ["a colina", "hill", "⛰️", "noun", "f", "A casa fica numa colina.", "The house sits on a hill."],
      ["o vale", "valley", "🏞️", "noun", "m", "O vale enche-se de nevoeiro ao amanhecer.", "The valley fills with fog at dawn."],
      ["a cascata", "waterfall", "💧", "noun", "f", "A cascata cai de grande altura.", "The waterfall drops from a great height."],
      ["a abelha", "bee", "🐝", "noun", "f", "As abelhas polinizam as flores.", "Bees pollinate the flowers."],
      ["a borboleta", "butterfly", "🦋", "noun", "f", "Uma borboleta atravessou o jardim.", "A butterfly crossed the garden."],
      ["o trilho", "path / trail", "🥾", "noun", "m", "Seguimos o trilho até ao cimo.", "We followed the trail to the top."],
      ["a margem", "shore / bank", "🌊", "noun", "f", "Caminhámos pela margem do rio.", "We walked along the river bank."],
    ],
  },
  {
    theme: "nature", tier: "B1", rows: [
      ["o ecossistema", "ecosystem", "🌍", "noun", "m", "A zona húmida é um ecossistema frágil.", "The wetland is a fragile ecosystem."],
      ["a desflorestação", "deforestation", "🪓", "noun", "f", "A desflorestação ameaça a fauna.", "Deforestation threatens the wildlife."],
      ["a bacia", "river basin", "🗺️", "noun", "f", "A bacia do Ebro é muito extensa.", "The Ebro basin is very large."],
      ["a jazida", "deposit / site", "⛏️", "noun", "f", "Encontraram uma jazida de carvão.", "They found a coal deposit."],
      ["a maré", "tide", "🌊", "noun", "f", "A maré baixa deixa conchas na areia.", "Low tide leaves shells on the sand."],
      ["autóctone", "native / indigenous", "🌱", "adjective", "", "O carvalho é uma espécie autóctone.", "The oak is a native species."],
      ["o afluente", "tributary", "🏞️", "noun", "m", "Esse rio é um afluente do Douro.", "That river is a tributary of the Duero."],
      ["o abate", "logging / felling", "🌲", "noun", "m", "O abate ilegal preocupa os moradores.", "Illegal logging worries the locals."],
      ["o caudal", "flow / volume of water", "💦", "noun", "m", "O caudal do rio baixa no verão.", "The river's flow drops in summer."],
      ["o predador", "predator", "🦅", "noun", "m", "O lince é um predador da floresta.", "The lynx is a forest predator."],
    ],
  },
];
